import { render, staticRenderFns } from "./AccordionManager.vue?vue&type=template&id=4562e09e&"
import script from "./AccordionManager.vue?vue&type=script&lang=js&"
export * from "./AccordionManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports